import React from "react";
import ContactAndMedia from "../components/headerComponents/contactAndMediaComponent";
import Navbar from "../components/headerComponents/navbarComponent";

const Header=()=>{

    return<div>
        <ContactAndMedia/>
        <Navbar/>
    </div>
}


export default Header;